import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { ButtonsetSingleWebElement } from './ButtonsetSingleWebElement';
export { ButtonsetSingleWebElement };

/**
 * Retrieve an instance of [ButtonsetSingleWebElement](../classes/ButtonsetSingleWebElement.html).
 * @example
 * ```javascript
 * import { findButtonsetSingle } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findButtonsetSingle(driver, By.id('my-oj-c-buttonset-single'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findButtonsetSingle(
  driver: DriverLike,
  by: By
): Promise<ButtonsetSingleWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type ButtonsetSingleWebElement
  if (!(webEl instanceof ButtonsetSingleWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'ButtonsetSingleWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findButtonsetSingle(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${ButtonsetSingleWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-buttonset-single', ButtonsetSingleWebElement);
